import dynamic from 'next/dynamic';
export default dynamic(() => import(/* webpackChunkName: "blazeAuthWsbLogin" */'./LoginComponent'));
//# sourceMappingURL=index.js.map